var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-info"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    clipPath: "url(#clip-info)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21197",
    "data-name": "Path 21197",
    d: "M35.586,9.255l-.145.593q-.652.257-1.041.392a2.746,2.746,0,0,1-.9.135,1.8,1.8,0,0,1-1.228-.385,1.247,1.247,0,0,1-.438-.978,3.461,3.461,0,0,1,.033-.471Q31.9,8.3,31.97,8l.543-1.924q.073-.276.122-.524a2.276,2.276,0,0,0,.049-.451.7.7,0,0,0-.152-.514.859.859,0,0,0-.581-.145,1.523,1.523,0,0,0-.432.066c-.148.044-.274.086-.38.125l.145-.593q.534-.217,1.022-.372a3.056,3.056,0,0,1,.924-.155,1.758,1.758,0,0,1,1.21.379,1.258,1.258,0,0,1,.425.985c0,.084-.009.231-.029.441a2.952,2.952,0,0,1-.109.58l-.541,1.916a5.087,5.087,0,0,0-.119.528,2.716,2.716,0,0,0-.053.448.645.645,0,0,0,.17.52.962.962,0,0,0,.592.138,1.71,1.71,0,0,0,.448-.069A2.5,2.5,0,0,0,35.586,9.255Zm.137-8.044a1.121,1.121,0,0,1-.379.853,1.289,1.289,0,0,1-.912.353,1.3,1.3,0,0,1-.916-.353,1.119,1.119,0,0,1-.382-.853,1.13,1.13,0,0,1,.382-.856,1.353,1.353,0,0,1,1.828,0A1.132,1.132,0,0,1,35.723,1.212Z",
    transform: "translate(-25.223 2.813)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.42c4dac76e3fe0dbcf73c9e1b64b9200.svg";
export { ForwardRef as ReactComponent };